/// <amd-module name="Wit/WorkItemForm/Details/LegacyWorkItemFormControl" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { Observer } from "VSSUI/Observer";
import { Spinner } from "VSSUI/Spinner";
import { IWorkItemLinkTypeEnd } from "Wit/WorkItemDataManager/Contracts";
import { LegacyWorkItem } from "Wit/WorkItemModel/WorkItem/LegacyWorkItem";

export interface ILegacyWorkItemFormControlProps {
    wrappedType: string;
    module: string;
    legacyWorkItem: () => LegacyWorkItem;
    linkTypeEnds: ObservableValue<IWorkItemLinkTypeEnd[] | undefined>;
}

export function LegacyWorkItemFormControl(props: ILegacyWorkItemFormControlProps) {
    return (
        <Observer key={props.wrappedType + "-observer"} linkTypes={props.linkTypeEnds}>
            {() => {
                if (props.linkTypeEnds.value !== undefined) {
                    return (
                        <LegacyComponent
                            modules={[props.module]}
                            wrappedType={props.wrappedType}
                            workItem={props.legacyWorkItem()}
                            linkTypeEnds={props.linkTypeEnds.value}
                        />
                    );
                } else {
                    return <Spinner key={props.wrappedType + "-spinner"} />;
                }
            }}
        </Observer>
    );
}
